
export const text = `

Billionares really are out of touch with the common folk. Who gives stock options as maze prizes?

The Intern has his work cut out for him.
`